import React from 'react';

import { TrackerObjectiveValueTypes } from 'constants/assignments';

import Icons from 'pages/Teachers/Assignments/Feedback/components/RightMenu/Icons';
import {
  GENERAL_CONCEPTUAL_UNDERSTANDING,
  SIGNIFICANT_ERRORS_IN_WORK,
  WORK_IS_COMPLETE_AND_CORRECT
} from 'pages/Teachers/Insights/constants';

import { MASTERY_LEVEL_TO_LABEL_MAPPER } from './constants';
import { MASTERY_LEVELS } from './constants';

export const shouldDisablePublish = ({ status, overallResponseStatus }) => {
  if (
    MASTERY_LEVEL_TO_LABEL_MAPPER[overallResponseStatus] ===
    MASTERY_LEVELS.NEEDS_REVIEW
  )
    return true;
  if (
    status === 'complete' &&
    overallResponseStatus === SIGNIFICANT_ERRORS_IN_WORK
  )
    return false;
  if (
    status === 'revise' &&
    [WORK_IS_COMPLETE_AND_CORRECT, GENERAL_CONCEPTUAL_UNDERSTANDING].includes(
      overallResponseStatus
    )
  )
    return false;
  if (status === 'complete' || status === 'revise') return true;

  return false;
};

export const getCheckGradeIcon = (grade) => {
  switch (grade) {
    case '0':
      return <Icons.Check fontSize="small" />;
    case '1':
      return <Icons.CheckPlus fontSize="small" />;
    case '-1':
      return <Icons.CheckMinus fontSize="small" />;
    default:
      return <Icons.Check fontSize="small" />;
  }
};

export const getRubricValueByRawValue = ({ rawValue }) => {
  switch (rawValue) {
    case 'a':
      return 4;
    case 'b':
      return 3;
    case 'c':
      return 2;
    case 'd':
      return 1;
    case 'f':
      return 0;
    case 'beginning':
      return 0;
    case 'approaching':
      return 1;
    case 'proficient':
      return 2;
    case 'excelling':
      return 3;
    case 'correct':
      return 1;
    case 'incorrect':
      return 0;
    default:
      return rawValue;
  }
};

export const getGradeLabel = ({ grade, objectiveValueType }) => {
  if (objectiveValueType === TrackerObjectiveValueTypes.CHECK_GRADE) {
    switch (grade) {
      case '-1':
        return 'Check Minus';
      case '0':
        return 'Check';
      case '+1':
        return 'Check Plus';
      default:
        return grade;
    }
  }

  return grade;
};
